import React, { useEffect, useState } from 'react';
import styles from './REsponseAINode.module.scss';
import NodeContainer from '../node-container/NodeContainer';
import { Handle, Position, useNodes } from '@xyflow/react';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import ResponseAiModal from './responseAi-Modal/ResponseAiModal';
import { useFetch } from 'hooks/useFetch';
import { knowledgeBase } from 'hooks/endpoints';
import { useWorkflowContext } from 'app-context/worflow/WorkflowContext';

const REsponseAiNode = ({ id, selected }) => {
  const { workflowData } = useWorkflowContext();
  const nodes = useNodes();
  const node = nodes.find((node) => node.id === id);
  const responseAi = node?.responseAi || {};

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isError, setIsError] = useState(node?.is_Error || false);
  const [materials, setMaterials] = useState([]);

  const {
    data: knowledgeBaseData,
    isFetching: isLoading,
    refetch: isRefetch,
  } = useFetch(
    ['knowledgeBase-data'],
    `${knowledgeBase?.getKnowledgeBase}`,
    { enabled: true },
    { botId: workflowData?.botId, pageSize: 1000, pageNumber: 1 }
  );

  useEffect(() => {
    if (node?.responseAi) {
      if (
        !node?.responseAi?.outputVariableId ||
        !node?.responseAi?.question ||
        !node?.responseAi?.responseThemeId
      ) {
        setIsError(true);
      } else {
        setIsError(false);
      }
    } else {
      setIsError(node?.is_Error || true);
    }
  }, [
    node?.responseAi,
    node?.responseAi?.outputVariableId,
    node?.responseAi?.question,
    node?.responseAi?.responseThemeId,
  ]);

  useEffect(() => {
    const knowledgeBaseDataOptions = knowledgeBaseData?.data?.items?.map(
      (item) => ({
        value: item.companyMaterialId,
        label: item.folderName ?? item.materialFileName,
        type: item.isURL ? 1 : item.isFolder,
      })
    );

    if (node?.responseAi?.aiMaterials?.length > 0) {
      const selectedMaterials = node.responseAi.aiMaterials.map((materialId) =>
        knowledgeBaseDataOptions?.find(
          (i) =>
            i.value === materialId.folderId || i.value === materialId.materialId
        )
      );
      setMaterials(selectedMaterials);
    } else {
      setMaterials([]);
    }
  }, [
    node?.responseAi,
    node?.responseAi?.aiMaterials?.length,
    knowledgeBaseData,
  ]);

  return (
    <>
      <NodeContainer
        title="Response AI Block"
        id={id}
        onClick={() => setIsModalOpen(true)}
        name={node?.title ?? 'Response AI Block'}
        backgroundColor={node?.color}
        selected={selected}
        node={node}
        isError={isError}
      >
        <Handle
          type="target"
          position={Position.Left}
          className="custom-handle"
        />

        <div className={styles['questions-cont']}>
          <div className={styles.svg}>
            <SvgWithBranding
              type="node-ai"
              color="#787878"
              className={styles.deleteIcon}
            />
            {!node?.responseAi?.question ||
            node?.responseAi?.question === '<p><br></p>' ? (
              <span className={styles.placeholder}>Enter a message</span>
            ) : (
              <div
                dangerouslySetInnerHTML={{
                  __html: responseAi.question,
                }}
              ></div>
            )}
          </div>

          {materials && materials?.length > 0 && (
            <div className={styles.folders}>
              {materials && materials?.length > 0 ? (
                materials?.map((item, index) => (
                  <div key={index} className={styles.svg}>
                    <SvgWithBranding
                      type={
                        item?.type === 1
                          ? 'url'
                          : item?.type === true
                          ? 'folder'
                          : 'table-file'
                      }
                      // color="#787878"
                      className={styles.deleteIcon}
                    />
                    <p className={styles.label}>{item?.label}</p>
                  </div>
                ))
              ) : (
                <div className={styles.svg}></div>
              )}
            </div>
          )}
          {node?.responseAi?.question && materials?.length === 0 ? (
            <div className={styles.svg}>
              <SvgWithBranding
                type="folder"
                // color="#787878"
                className={styles.deleteIcon}
              />
              <p className={styles.label}>All</p>
            </div>
          ) : null}
        </div>

        {/* <div className={styles.question}>
            <div className={styles.svg}>
              <SvgWithBranding
                type="node-file"
                color="#787878"
                className={styles.deleteIcon}
              />
              {responseAi.promptDescription ? (
                <p>{responseAi.promptDescription}</p>
              ) : (
                <span className={styles.placeholder}>
                  No Prompt Description
                </span>
              )}
            </div>
          </div> */}

        {/* <div className={styles.question}>
            <div className={styles.svg}>
              <SvgWithBranding
                type="variable"
                color="#787878"
                className={styles.deleteIcon}
              />
              {responseAi.Variables ? (
                <p>{responseAi.Variables}</p>
              ) : (
                <span className={styles.placeholder}>No Variables</span>
              )}
            </div>
          </div> */}
        <Handle
          type="source"
          position={Position.Right}
          className="custom-handle"
        />
      </NodeContainer>

      <ResponseAiModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        id={id}
        title="Response AI"
        knowledgeBaseData={knowledgeBaseData}
        isLoading={isLoading}
        isError={isError}
      />
    </>
  );
};

export default REsponseAiNode;
